import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BreadcrumbService } from '../services/app/breadcrumb.service';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbGuard implements CanActivate {

    constructor(private breadcrumbService: BreadcrumbService) {

    }

    /**
     * Get the current page path and update the breadcrumb service
     * @param route
     * @param state
     * @returns
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let url: string = '';
        if (route.url) {
            if (route.url.length == 1){
                url = '/' + route.url[0].path;
            } else {
                if (route.url.length > 1) {
                    for(let i = 0; i < 2; i++) {
                        url += '/' + route.url[i].path;
                    }
                }
            }
            this.breadcrumbService.update(url);
        }

        return true;
    }

}
